import { Constants } from "../utils/constants";
import { CookieService } from './cookie.service';
import { Utils } from "../utils/utils";

export const campaignFilterOptions = (filterObj, parentId) => {
  const modifiedFilter = { ...filterObj };
  modifiedFilter['startDate'] = Utils.convertToYYYYMMDD(filterObj['startDate']);
  modifiedFilter['endDate'] = Utils.convertToYYYYMMDD(filterObj['endDate']);
  let mapObj = {
    "campaignName": "campaign-name",
    "startDate": "start-date",
    "endDate": "end-date",
    "budgetMin": "net-media-min",
    "budgetMax": "net-media-max",
    "status": "export-status",
    "clientName": "client-id",
    "clientCode": "client-code-planit",
    "productCode": "product-code-planit",
    "estimateCode": "estimate-code-planit",
    "orderedNetMediaMax": "order-net-media-max",
    "orderedNetMediaMin": "order-net-media-min",
    "plannedNetMediaMax": "planned-net-media-max",
    "plannedNetMediaMin": "planned-net-media-min"
  };
  let filterParams = {};
  for (let key in modifiedFilter) {
    if (modifiedFilter[key] !== "") {
      filterParams[mapObj[key] || key] = modifiedFilter[key];
    }
  }
  return filterParams;
};

export const prepareFilterOptions = (filterObj) => {
  let mapObj = {
    "placementName": "placement-taxonomy",
    "startDate": "flight-start",
    "endDate": "flight-end",
    "status": "export-status",
    "total": "placement-cost",
    "plannedCostMin": "planned-cost-min",
    "plannedCostMax": "planned-cost-max",
    "unitsMin": "unit-amount-min",
    "unitsMax": "unit-amount-max",
    "rateMin": "rate-min",
    "rateMax": "rate-max",
  };
  let firlterParams = {};
  for (let key in filterObj) {
    if (filterObj[key] !== "") {
      firlterParams[mapObj[key]] = filterObj[key];
    }
  }
  return firlterParams;
};

export const getTodaysDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');
  const milliseconds = String(currentDate.getMilliseconds()).padStart(3, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
};

export const getSource = (source) => {
  const words = source.split(" ");
  const capitalizedWords = words.map(word => {
    const firstLetter = word[0]?.toUpperCase();
    const restOfWord = word.slice(1);
    return firstLetter + restOfWord;
  });
  return capitalizedWords.join(" ");
};

export const getChannels = (values) => {
  let channel = values?.length && values.map(val => val.channel_display_name || val.channel_name);
  let channelString = channel.toString();
  return channelString;
};

export const getPartnerString = (values) => {
  let partners = values?.partners;
  partners?.length && partners.forEach((val, index) => {
    if (val == null) {
      partners.splice(index, 1);
    }
  });
  return partners?.toString();
};

export const concatenateDotsInString = (value, number) => {
  return value.length <= number ? value : value.substring(0, number).concat('...');
};

export const getSubmittedVersion = (filerevision) => {
  if (filerevision && typeof filerevision !== 'string') {
    return Math.max(...filerevision.map(Number));
  } else {
    return filerevision;
  }
};

export const hasNonEmptyValue = (obj) => {
  if (obj == null) return false;
  return Object.values(obj).some(value => {
    if (typeof value === 'object' && value !== null) {
      return Object.keys(value).length > 0;
    }
    return value !== undefined && value !== '';
  });
};

export const getStatusColor = (status) => {
  const errorStatus = ["needs approval", "sync error", "rejected", "synthetic id missing", "taxonomy error", "updated", "needs update"];
  const commonStatus = ["not approved", "not exported", "sent to seller", "not synced"];
  if (!status) return "#1a8978";
  const lowerCaseStatus = status.toLowerCase();
  if (commonStatus.includes(lowerCaseStatus)) {
    return "#8b8d90";
  } else if (errorStatus.includes(lowerCaseStatus) || lowerCaseStatus.includes("error")) {
    return "#9b373c";
  }
  return "#1a8978";
};
